<ng-container class="exposition_consumers_mapping" *ngIf="vo$ | async; let vo">
	<app-panel
		headerHeight="3rem"
		isAlwaysOpen="true"
		hasSearchableGrid="true"
		maxActionsCount="6"
		[itemsCount]="vo.consumersToMapList.elements.size"
		[actions]="panelActions"
		[actionsAvailable]="toggleActions"
		(search)="search($event)">
		<span
			panel-title
			i18n="@@exposition.migration.stepper.secondStep.grid.title">
			consumers_mapping_grid
		</span>

		<div panel-info class="exposition_consumers_mapping__info">
			<div *ngIf="selectionCount">
				<span>{{ selectionCount }} &#32;</span>
				<span i18n="@@expositions.columns.config.selectedElements">
					selected-elements
				</span>
			</div>

			<div
				class="mapping-error error"
				*ngIf="vo.consumersToMapList.hasNoMapping">
				<mat-icon [svgIcon]="DcIcons.Warning"></mat-icon>
				<span i18n="@@expositions.consumers.mapping.config.alert.noMapping">
					no-mapping
				</span>
			</div>
		</div>

		<dx-data-grid
			keyExpr="id"
			[elementAttr]="{ id: 'consumer-list', class: 'consumer-mapping-list' }"
			[repaintChangesOnly]="true"
			[dataSource]="vo.consumersToMapList.elements | toArray"
			[hoverStateEnabled]="true"
			[showColumnHeaders]="true"
			[allowColumnResizing]="true"
			[columnAutoWidth]="false"
			[showRowLines]="false"
			[showColumnLines]="false"
			[rowAlternationEnabled]="false"
			[showBorders]="false"
			[width]="'100%'"
			(onCellHoverChanged)="onCellHover($event)"
			(onContentReady)="onGridContentReady($event)"
			(onSelectionChanged)="onSelectionChange($event)">
			<dxo-selection
				mode="multiple"
				showCheckBoxesMode="always"></dxo-selection>

			<dxo-load-panel
				shadingColor="rgba(0,0,0,0)"
				[indicatorSrc]="DcLoaders.LoaderInfinite"
				[height]="100"
				[width]="100"
				[enabled]="true"
				[showIndicator]="true"
				[showPane]="true"
				[shading]="true"></dxo-load-panel>

			<!-- Fixable in position columns	-->
			<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

			<ng-container
				*ngFor="let col of vo.consumersToMapList.availableColumns | toArray">
				<dxi-column
					*ngIf="col.field === 'isGroup'"
					[dataField]="col.field"
					[dataType]="col.type"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[fixed]="false"
					[allowResizing]="true"
					[allowHiding]="true"
					[allowGrouping]="true"
					[visible]="col.visible"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable"
					[allowSorting]="col.canBeReordered"
					[allowHeaderFiltering]="col.hasHeaderFilter"
					[alignment]="'left'"
					[visibleIndex]="col.visibleIndex"
					[width]="col.width"
					cellTemplate="memberTypeTemplate">
					<dxo-header-filter
						[dataSource]="memberTypesHeaderFilter"></dxo-header-filter>
				</dxi-column>

				<dxi-column
					*ngIf="col.field === 'fullName'"
					[dataField]="col.field"
					[dataType]="col.type"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[fixed]="false"
					[allowResizing]="true"
					[allowHiding]="true"
					[allowGrouping]="true"
					[visible]="col.visible"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable"
					[allowSorting]="col.canBeReordered"
					[allowHeaderFiltering]="col.hasHeaderFilter"
					[alignment]="'left'"
					[visibleIndex]="col.visibleIndex"
					[width]="col.width"></dxi-column>

				<dxi-column
					*ngIf="col.field === 'targetConsumers'"
					[dataField]="col.field"
					[dataType]="col.type"
					[caption]="col.alias"
					[groupIndex]="col.groupIdx"
					[fixed]="false"
					[allowResizing]="true"
					[allowHiding]="true"
					[allowGrouping]="true"
					[visible]="col.visible"
					[allowSearch]="col.isSearchable"
					[allowFiltering]="col.isFilterable"
					[allowSorting]="col.canBeReordered"
					[allowHeaderFiltering]="col.hasHeaderFilter"
					[filterOperations]="[DxOperations.Contains, DxOperations.In]"
					[calculateFilterExpression]="calculateTargetsFilterExpression"
					[alignment]="'left'"
					[visibleIndex]="col.visibleIndex"
					[width]="col.width"
					cellTemplate="targetTemplate">
					<dxo-header-filter
						[dataSource]="targetsHeaderFilter"></dxo-header-filter>
				</dxi-column>
			</ng-container>

			<dxi-column
				[fixed]="false"
				[allowResizing]="false"
				[allowHiding]="false"
				[allowGrouping]="false"
				[allowSearch]="false"
				[allowSorting]="false"
				[alignment]="'left'"
				[visibleIndex]="vo.consumersToMapList.availableColumns.size + 1"
				[showInColumnChooser]="false"
				[width]="'10rem'"
				cellTemplate="actionsTemplate"></dxi-column>

			<div class="icon-template" *dxTemplate="let cell of 'memberTypeTemplate'">
				<app-avatar
					*ngIf="!cell.data['isGroup'] && cell.data['avatar']"
					[avatar]="cell.data['avatar']"
					[withTooltip]="true"></app-avatar>
				<mat-icon
					*ngIf="cell.data['isGroup']"
					[svgIcon]="DcIcons.Group"></mat-icon>
			</div>

			<div class="target-template" *dxTemplate="let cell of 'targetTemplate'">
				<app-chip
					*ngFor="let item of cell.data['targetConsumers'] | toArray"
					viewMode="default"
					(remove)="removeSelectedTargetConsumer(cell.data, item)">
					<mat-icon
						*ngIf="item.isGroup"
						[svgIcon]="DcIcons.Group"
						app-chip-icon></mat-icon>
					<app-avatar
						*ngIf="!item.isGroup && item.avatar"
						[avatar]="item.avatar"
						app-chip-icon></app-avatar>
					<span>{{ item.name }}</span>
				</app-chip>
			</div>

			<div
				class="actions-column-template"
				*dxTemplate="let cell of 'actionsTemplate'">
				<div [hidden]="cell.rowIndex !== currentlyHovered">
					<button
						id="{{ cmpId }}-{{ cell.rowIndex }}-mapper-btn"
						mat-icon-button
						class="actions-column-template__btn"
						matTooltip="mapper"
						i18n-matTooltip="@@expositions.consumers.mapping.uniMapping.btn"
						(click)="uniMapping(cell.data)">
						<mat-icon [svgIcon]="ActionIcons.Mapper"></mat-icon>
					</button>
					<button
						id="{{ cmpId }}-{{ cell.rowIndex }}-reset-btn"
						mat-icon-button
						class="actions-column-template__btn"
						matTooltip="reset"
						i18n-matTooltip="@@expositions.consumers.mapping.reset.btn"
						(click)="resetMapping(cell.data)">
						<mat-icon [svgIcon]="DcIcons.ResetSelection"></mat-icon>
					</button>
					<button
						id="{{ cmpId }}-{{ cell.rowIndex }}-auto-btn"
						mat-icon-button
						class="actions-column-template__btn"
						matTooltip="auto"
						i18n-matTooltip="@@expositions.consumers.mapping.autoMapping"
						(click)="autoMapping(cell.key)">
						<mat-icon [svgIcon]="ActionIcons.AutoMap"></mat-icon>
					</button>
				</div>
			</div>

			<dxo-group-panel [visible]="false"></dxo-group-panel>

			<!-- Filterable columns	-->
			<dxo-filter-row
				[visible]="vo.consumersToMapList.elements.size !== 0"></dxo-filter-row>

			<!-- Sorting	-->
			<dxo-sorting mode="multiple"></dxo-sorting>

			<!-- Pagination -->
			<dxo-paging [pageSize]="50"></dxo-paging>
			<dxo-pager
				[visible]="true"
				[showPageSizeSelector]="true"
				[allowedPageSizes]="[50]"></dxo-pager>

			<!-- Filterable columns	-->
			<dxo-header-filter [visible]="true"></dxo-header-filter>

			<dxo-filter-panel [visible]="true"></dxo-filter-panel>
		</dx-data-grid>
	</app-panel>
</ng-container>
